import React from 'react';
import { useState } from 'react';
import InputError from "../InputError";
import './FileUpload.scss';

export default function FileUpload({ label, placeholder, error, onFileChange, multiple = false, ...rest })
{
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [dragActive, setDragActive] = useState(false);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        setSelectedFiles(prevFiles => [...prevFiles, ...files]);
        onFileChange([...selectedFiles, ...files]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragActive(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragActive(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragActive(false);
        const files = Array.from(e.dataTransfer.files);
        setSelectedFiles(prevFiles => [...prevFiles, ...files]);
        onFileChange([...selectedFiles, ...files]);
    };

    return (

        <div className={"file-upload" + (rest.required ? ' required ' : '')}>
            {label ? <label htmlFor="fileInput" className="form-label">{label}</label> : null}
            <input
                {...rest}
                id="fileInput"
                type="file"
                onChange={handleFileChange}
                style={{display: 'none'}}
                multiple={multiple}
            />
            <div
                className={`file-drop-area ${dragActive ? 'drag-active' : ''}`}
                onClick={() => document.getElementById('fileInput').click()}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <p className="file-placeholder">{placeholder}</p>
            </div>
            <ul className="file-list">
                {selectedFiles.map((file, index) => (
                    <li key={index} className="file-item">
                        <span className="file-name">{file.name}</span>
                        <button className="file-remove" onClick={() => handleRemoveFile(index)}>×</button>
                    </li>
                ))}
            </ul>
            {error ? <InputError error={error}/> : null}
        </div>
    );

    function handleRemoveFile(index) {
        const updatedFiles = selectedFiles.filter((_, i) => i !== index);
        setSelectedFiles(updatedFiles);
        onFileChange(updatedFiles);
    }
}